import { IMAGE_UPLOAD } from '../constants';

export const validateImageFile = (file) => {
  if (!file) return { valid: false, error: 'Nessun file selezionato' };
  if (!IMAGE_UPLOAD.ALLOWED_TYPES.includes(file.type)) {
    return {
      valid: false,
      error: 'Formato non supportato. Usa JPEG, PNG, WebP o GIF.',
    };
  }
  if (file.size > IMAGE_UPLOAD.MAX_SIZE_BYTES) {
    const maxMb = IMAGE_UPLOAD.MAX_SIZE_BYTES / 1024 / 1024;
    return {
      valid: false,
      error: `Immagine troppo grande. Max ${maxMb}MB.`,
    };
  }
  return { valid: true };
};

export const readFileAsDataURL = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
